<template>
  <div class="af-card">
    <span v-if="loading">
      <b-skeleton width="80%" :animated="true"></b-skeleton>
    </span>
    <span v-else>
      <span v-if="successfulConfirmation || isAlreadyConfirmed">
        <img
          class="mx-auto is-block mb-3"
          :src="require('@/assets/images/email-confirmation-success.svg')"
          alt="email-confirmation-success"
        />

        <p class="is-size-3 has-text-weight-bold center mb-5">
          <label v-if="successfulConfirmation">
            {{ $t("af:email_confirmation.successful.title") }}
          </label>

          <label v-else>
            {{ $t("af:email_confirmation.already_confirmed.title") }}
          </label>
        </p>

        <p class="mb-6">
          {{ $t("af:email_confirmation.successful.subtitle") }}
        </p>

        <p class="has-text-weight-bold has-text-centered mb-4">
          <a @click="backToTheApplication">
            {{ $t("af:email_confirmation.button.back_to_page") }}</a
          >
        </p>
      </span>
      <span v-else>
        <img
          class="mx-auto is-block mb-3"
          :src="require('@/assets/images/email-confirmation-failed.svg')"
          alt="email-confirmation-failed"
        />

        <p class="is-size-3 has-text-weight-bold center mb-5">
          {{ $t("af:email_confirmation.unsuccessful.title") }}
        </p>

        <span v-if="loggedIn">
          <span v-if="!newCodeSent">
            <p class="mb-5">
              {{ $t("af:email_confirmation.unsuccessful.logged_in.subtitle") }}
            </p>
            <b-button type="is-blue" @click="sendNewCode" expanded>{{
              $t("af:email_confirmation.button.send_new_code")
            }}</b-button>
          </span>

          <span v-else>
            <p class="mb-5">
              <span
                v-html="
                  $t('af:email_confirmation.new_code_sent_title', {
                    email: currentEmail,
                  })
                "
              ></span>
            </p>
          </span>
        </span>

        <div v-else>
          <p class="mb-5">
            {{
              $t("af:email_confirmation.unsuccessful.not_logged_in.subtitle")
            }}
          </p>
        </div>
      </span>
    </span>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { generateNonce } from "../utils/util";

export default {
  name: "EmailConfirmation",
  title: "af:page.email_confirmation.title",
  data() {
    return {
      successfulConfirmation: false,
      isAlreadyConfirmed: false,
      newCodeSent: false,
      currentEmail: "",
      loading: true,
    };
  },
  computed: {
    ...mapGetters({
      loggedIn: "session/isReady",
    }),
    url() {
      if (this.loggedIn) {
        return this.$store.getters["profile/getBackPath"];
      }
      return "/login";
    },
  },
  async created() {
    let id = this.$route.query.id;
    let code = this.$route.query.code;
    let nonce = this.$route.query.nonce;

    if (!id || !code || !nonce) {
      if (this.loggedIn) {
        await this.$router.push("/profile");
      } else {
        await this.$router.push("/login");
      }
    } else {
      if (this.loggedIn) {
        let isEmailConfirmedResponse = await this.$store.dispatch(
          "profile/isEmailConfirmed"
        );
        this.isAlreadyConfirmed = isEmailConfirmedResponse.isEmailConfirmed;
        this.currentEmail = isEmailConfirmedResponse.currentEmail;
      }

      if (!this.isAlreadyConfirmed) {
        try {
          await this.$store.dispatch("session/confirmEmail", {
            id: id,
            code: code,
            nonce: nonce,
          });
          this.successfulConfirmation = true;
        } catch (ex) {
          console.error(ex);
        }
      }

      if (this.successfulConfirmation || this.isAlreadyConfirmed) {
        setTimeout(() => {
          this.backToTheApplication();
        }, 5000);
      }

      this.loading = false;
    }
  },
  methods: {
    async backToTheApplication() {
      let emailConfirmationDataResponse = await this.$store.dispatch(
        "profile/getEmailConfirmationData"
      );

      if (this.url === "/offers") {
        await this.$router.push({
          name: "Offers",
          params: { offerIdToOpen: emailConfirmationDataResponse.offerId },
        });
      } else {
        await this.$router.push(this.url);
      }
    },
    async sendNewCode() {
      await this.$store.dispatch(
        "profile/sendConfirmationEmail",
        { nonce: generateNonce(), isLeasing:false}
      );
      this.newCodeSent = true;
    },
  },
};
</script>

<style scoped lang="scss">
.af-card {
  background: white;
  border-radius: 16px;
  padding: 20px;
}

@media only screen and (min-width: 769px) {
  .af-card {
    padding: 40px 80px;
  }
}
</style>
